<script>
  import { db } from "../etc/firebase.js"
  import "materialize-css"
  import {
    btn_style_blue_d2,
    btn_style_red_d2,
    btn_style_yellow_d2,
    btn_style_teal,
    btn_style_orange_d2,
  } from "../etc/helpers.js"
  export let id = ""
  export let member = {}

  let editMember = false

  const deleteMember = () => {
    if (confirm("Are you sure to delete this Member?")) {
      if (
        confirm(
          "REALLY?? Let's double confirm: Are you sure to delete this Member?"
        )
      ) {
        db.collection("xiyiMembers").doc(id).delete()

        alert("Member Deleted!")
        showDetail = false
      }

      // showSummary = false
      // guaDeleted = true
    } else {
      // showSummary = false
      // guaDeleted = false
    }
  }

  let newAdminNote = ""
  let addedDays = 0
  // console.log("@ Member: " + member)
  function addDays(day) {
    let dayMs = day * 24 * 60 * 60 * 1000

    db.collection("xiyiMembers")
      .doc(id)
      .update({
        subscriptionExpireOn: member.subscriptionExpireOn + dayMs,
        lastPaymentDT: Date.now(),
        lastPayment: 0,
        currencyType: "USD",
        //adminNote: member.adminNote.push(newAdminNote),
      })
      .then(() => {
        addedDays = 0
        editMember = false
      })
  }

  // const updateMember = () => {
  //   db.collection("xiyiMembers").doc(id).update({
  //     updatedDT: note.updatedDT,
  //     title: note.title,
  //     published: note.published,
  //     content: note.content,
  //   })

  //   editMember = false
  // }

  // The follow code is for DOM ops
  let showDetail = false
  // console.log("record.qiGuaDT type is ->")
  // console.log(typeof record.qiGuaDT)
  function showHideMemberDetail() {
    showDetail = !showDetail
  }

  // Edit mode
  function enableEditMode() {
    editMember = true
  }
</script>

<a href="#" class="blue-text collection-item" on:click={showHideMemberDetail}>
  {member.userName} / {member.userAlias}
</a>

<div class="card indigo lighten-5">
  <div
    class="card-body member-content"
    style="display:{showDetail ? 'block' : 'none'}"
  >
    <table class="xiyiadmin-member-tbl indigo lighten-5">
      <thead>
        <tr>
          <th class="item-field">Firebase fieldName</th>
          <th class="item-field">Content</th>
          <th>Manage</th>
        </tr>
      </thead>

      <tbody>
        <tr>
          <td class="item-field">離到期日剩</td>
          <td
            style={new Date(member.subscriptionExpireOn) -
              new Date().getTime() <
            0
              ? "color:#ff0000;"
              : ""}
          >
            {Math.round(
              ((new Date(member.subscriptionExpireOn) - new Date().getTime()) /
                (1000 * 60 * 60 * 24) +
                Number.EPSILON) *
                100
            ) / 100} 天
            <!-- {(new Date(member.subscriptionExpireOn) - new Date().getTime()) /
              (1000 * 60 * 60 * 24)} -->
          </td>
          <td><span>能更改。</span></td>
        </tr>
        <tr>
          <td class="item-field">Add More Days</td>
          <td> <input type="number" bind:value={addedDays} /> </td>
          <td
            ><button
              on:click={() => addDays(addedDays)}
              class={btn_style_blue_d2}>Add More Days</button
            ></td
          >
        </tr>
        <tr>
          <td class="item-field">firebaseUid</td>
          <td>{member.firebaseUid}</td>
          <td><span>不能更改。</span></td>
        </tr>
        <tr>
          <td class="item-field">createdDT</td>
          <td>{new Date(member.createdDT)}</td>
          <td><span>不能更改。</span></td>
        </tr>
        <tr>
          <td class="item-field">email</td>
          <td>{member.email}</td>
          <td><span>不能更改。</span></td>
        </tr>
        <tr>
          <td class="item-field">userName</td>
          <td>{member.userName}</td>
          <td><span>不能更改。?</span></td>
        </tr>
        <tr>
          <td class="item-field">userAlias</td>
          <td>{member.userAlias}</td>
          <td><span>不能更改。?</span></td>
        </tr>
        <tr>
          <td class="item-field">country</td>
          <td>{member.country}</td>
          <td><span>不能更改。?</span></td>
        </tr>
        <tr>
          <td class="item-field">city</td>
          <td>{member.city}</td>
          <td><span>不能更改。?</span></td>
        </tr>
        <tr>
          <td class="item-field">phone</td>
          <td>{member.phone}</td>
          <td><span>不能更改。?</span></td>
        </tr>
        <tr>
          <td class="item-field">qiMonthlyGoal</td>
          <td>{member.qiMonthlyGoal}</td>
          <td><span>不能更改。?</span></td>
        </tr>
        <tr>
          <td class="item-field">subscriptionBeginOn</td>
          <td>{new Date(member.subscriptionBeginOn)}</td>
          <td><span>不能更改。?</span></td>
        </tr>
        <tr>
          <td class="item-field">subscriptionExpireOn</td>
          <td>{new Date(member.subscriptionExpireOn)}</td>
          <td><span>不能更改。</span></td>
        </tr>
        <tr>
          <td />
          <td />
          <td
            ><button class="btn red  right" on:click={deleteMember}
              >🗑️ DELETE MEMBER</button
            >
          </td>
        </tr>
      </tbody>
    </table>

    <div class="member-box">
      <div class="show-member" style="display:{editMember ? 'block' : 'none'}">
        <textarea
          type="materialize-textarea"
          id="member-content"
          placeholder={member.content}
          bind:value={member.content}
        />
      </div>
      <br />
      <div class="btns">
        <!-- <button
          class="waves-effect waves-light blue darken-1 btn"
          style="display:{editMember ? 'none' : 'block'}"
          on:click={enableEditMode}>Edit</button
        > -->
        <!-- <button
          class="waves-effect waves-light lime darken-2 btn"
          style="display:{editMember ? 'block' : 'none'}"
          on:click={updateMember}>Update</button
        > -->
        <!-- <button class="btn red  right" on:click={deleteMember}
          >🗑️ DELETE MEMBER</button
        > -->
      </div>
    </div>
  </div>
</div>

<!-- </li> -->
<style>
  .member-box {
    /* display: grid;
    grid-template-columns: 3fr 1fr; */
  }
  .member-title {
    width: 100%;
  }
  .member-content {
    margin: 20px;
    padding-top: 10px;
    padding-bottom: 10px;
  }
  #member-content {
    background-color: white;
  }
  .member {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
    grid-gap: 10px;
  }
</style>
